<template>
	<v-main>
		<div
			ref="topPage"
			class="head-banner pb-12 pb-md-0"
		>
			<div class="py-6">
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							class="mx-auto px-5 px-sm-10"
						>
							<div
								class="d-flex align-start"
								style="white-space: nowrap;"
							>
								<v-btn
									color="#000"
									elevation="0"
									class="mt-n1"
									fab
									x-small
									dark
									:to="{ name: 'index' }"
								>
									<v-icon>mdi-home</v-icon>
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span>บทความ</span>

								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span>บทความรีวิว</span>
							</div>
							<div class="search-filter white--text">
								<span>บทความ</span>

								<div class="pl-3 pr-5">
									บทความรีวิว
								</div>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div style="height: 300px;">
				<z-img
					:storage="bannerImg"
					max-width="100%"
					height="300"
				/>
			</div>
		</div>

		<div class="bg-red-red">
			<v-container class="pa-0">
				<v-row
					class="recommend justify-center"
					no-gutters
				>
					<v-col xl="8">
						<h2 class="text-center my-7">
							บทความรีวิว<span class="red--text">แนะนำ</span>
						</h2>

						<articleReviewCarousel
							:items="recommendList"
							white
							class="px-md-12"
							style="margin-bottom: 60px;"
						/>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="pb-6">
			<v-container class="pa-6">
				<v-row no-gutters>
					<v-col
						ref="top"
						xl="8"
						class="mx-auto"
					>
						<v-row>
							<v-col
								cols="12"
								class="pt-6 pb-4 text-center"
							>
								<h2>
									<span>รีวิว</span><span class="colorRed">โครงการบ้าน</span>
								</h2>
							</v-col>
							<v-col
								v-for="(article, i) in loading ? parseInt(perPage) : list"
								:key="`${i+1}-${article.slug || i}`"
								cols="12"
								sm="6"
								md="4"
								lg="3"
							>
								<articleReviewItem
									:article="article"
									elevation="10"
								/>
							</v-col>

							<v-col
								cols="12"
								class="px-0 px-md-3"
							>
								<div class="d-flex justify-center justify-md-space-between align-center mx-n3 px-md-3 text-center">
									<div
										class="d-none d-md-block"
										style="white-space: nowrap;"
									>
										<span class="red--text">{{ totalItem }}</span> รายการ
									</div>
									<v-pagination
										v-model="page"
										:length="totalPage"
										:total-visible="10"
									/>
								</div>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</v-main>
</template>

<script>
const doc = 'blog_review'

import { mapGetters } from 'vuex'

import articleReviewItem from '~/components/2.0/article-review-item'
import articleReviewCarousel from '~/components/2.0/article-review-carousel'

export default {
	// scrollToTop: true,
	name: 'BLOGREVIEW',
	layout: 'default_2',

	components: {
		articleReviewItem,
		articleReviewCarousel,
	},

	async asyncData(context) {
		let article = await context.app.$fireStore.collection('articles')
			.where('category', '==', 'property-review')
			.where('published', '==', true)
			.orderBy('created_at', 'desc')
			// .limit(13)
			.get()

		let articleList = article.docs.filter((item, i) => i > 5).map(item => item.data())
		let recommendList = article.docs.filter((item, i) => i < 6).map(item => item.data())

		await context.store.dispatch('page/initial', {
			doc,
			fullPath: context.route.fullPath
		})

		return {
			articleList,
			recommendList,
			perPage: 12,
			total: articleList.length
		}
	},

	data:() => ({
		keepAliveActivated: false,
		loading: false,
		page: 1,
		maxHeight: '100%'
	}),

	computed: {
		...mapGetters({
			head: 'page/head',
		}),

		list () {
			return this.articleList.slice((this.page - 1) * this.perPage, this.page * this.perPage)
		},

		totalPage () {
			return Math.ceil(this.total / this.perPage)
		},

		totalItem () {
			return new Intl.NumberFormat('th-TH', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(this.total)
		},

		bannerImg () {
			return '/images/2.0/article-banner.jpg'
		},
	},

	watch: {

	},

	activated () {
		if (window.windowNavigate) {
			window.windowNavigate = false
		} else if (this.keepAliveActivated) {
			// this.search()
		}
	},

	created() {

	},

	mounted() {

	},

	methods: {

	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
h1 {
	font-size: 1.6em;
}
.head-banner {
	position: relative;

	.search-filter {
		position: absolute;
		top: 155px;
		z-index: 2;

		span {
			font-size: 3em;
		}
		div {
			border-left: solid 4px #c20000;
			font-size: 2em;
		}
	}
}
.bg-red-red {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(237,28,36,1) 50%, rgba(237,28,36,1) 100%);

	&::before {
		content: ' ';
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 50%;

		background: rgb(255,255,255);
		background: linear-gradient(180deg, rgba(157,30,37,1) 0%,rgba(157,30,37,1) 60%, rgba(255,255,255,1) 60%, rgba(255,255,255,1) 100%);
	}
}
.recommend > div {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(237,28,36,1) 50%, rgba(237,28,36,1) 100%);

	&::before {
		content: ' ';
		background: rgb(237,28,36);
		background: linear-gradient(180deg, rgba(157,30,37,1) 0%, rgba(157,30,37,1) 60%, rgba(237,28,36,1) 60%, rgba(237,28,36,1) 100%);
		position: absolute;
		width: 14%;
		left: -8%;
		top: 0;
		bottom: 0;

		@media (max-width: 959px) {
			& {
				width: 0;
			}
		}
	}
}

.v-pagination ::v-deep {
	position: relative;

	li {
		button {
			border-radius: unset;
			box-shadow: unset;
			height: 34px;
		}

		&:first-child, &:last-child {
			position: absolute;
			right: 0;

			button {
				background-color: #3a3a3a;
				margin: 0;

				// @media (min-width: 600px) {
				// 	margin: auto 10px;
				// }

				i {
					color: #fff;
				}
			}
		}
		&:first-child {
			left: 0;
			right: unset;

			@media (min-width: 960px) {
				right: 34px;
				left: unset;
			}
		}
		&:nth-child(2) {
			@media (min-width: 960px) {
				margin-left: -90px;
			}
		}
	}
}
</style>
